import { clientAuth } from './client'

const loginService = {}

loginService.login = function (data) {
  const loginUser = 'login'
  return clientAuth.post(loginUser, data)
    .then(res => {
      return res
    })
    .catch(error => {
      return error
    })
}

export default loginService